import { variant } from 'styled-system';
export const font = (props) => {
    const { theme } = props;
    return variant({
        prop: 'font',
        variants: theme.fonts,
    })(props);
};
//# sourceMappingURL=font.js.map